import { Button, message, Row } from 'antd'
import { inject } from 'mobx-react'
import React, { FC, useContext, useEffect, useState } from 'react'
import { LoadingAnimation } from '../../../../components/LoadingAnimation'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { parseErrorMsg } from '../../../../utilities/helpers'
import { DigitalSignageCard } from './DigitalSignageCard'
import { DigitalSignageContext } from './DigitalSignageContext'
import {
  DigitalSignageAPIState,
  DigitalSignageCardType,
  DigitalSignageDeleteMessage,
} from './enums'
import SignageModal from './SignageModal'

interface ISignagePageProps {
  currentCompanyStore?: CurrentCompanyStore
}

interface ISignageSection {
  id: string
  title: string
  osQuery: string
  maxItems: number
  fields: string[]
}
export interface ISignageContract {
  id: string
  name: string
  tenantId: string
  tenantName: string
  templateLink: string
  primaryColor: string
  secondaryColor: string
  backgroundColor: string
  allowedOrientations: number[]
  sections: ISignageSection[]
}

export const SignagePage: FC<ISignagePageProps> = inject('currentCompanyStore')(
  ({ currentCompanyStore }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const company = currentCompanyStore?.company
    const [isEditing, setEditMode] = useState(false)
    const [currentSignage, setCurrentSignage] = useState<ISignageContract>()

    const { getSignages, signages, status } = useContext(DigitalSignageContext)

    useEffect(() => {
      try {
        getSignages(company?.id.toString() || '')
      } catch (error) {
        message.error(parseErrorMsg(error))
      }
    }, [])

    const handleEdit = (signage: ISignageContract) => {
      setCurrentSignage(signage)
      setEditMode(true)
      setIsModalOpen(true)
    }

    return (
      <>
        <Row>
          <Button
            type='primary'
            size='large'
            style={{ position: 'absolute', right: 0, zIndex: 1 }}
            onClick={() => {
              setEditMode(false)
              setIsModalOpen(true)
            }}
          >
            Add new signage
          </Button>
          <SignageModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            isEditing={isEditing}
            currentSignage={currentSignage}
          />
          <Row>
            <section className='mt-5 pb-4 mb-4 card-wrapper'>
              <div className='d-flex flex-wrap'>
                {status === DigitalSignageAPIState.FETCHING_SIGNAGES ? (
                  <LoadingAnimation />
                ) : signages.length > 0 ? (
                  signages.map((signage) => {
                    return (
                      <DigitalSignageCard
                        key={signage.id}
                        title={signage.name}
                        buttonText={'Edit'}
                        id={signage.id}
                        type={DigitalSignageCardType.SIGNAGE}
                        deleteMessage={DigitalSignageDeleteMessage.DELETE_SIGNAGE}
                        onButtonClick={() => handleEdit(signage)}
                      />
                    )
                  })
                ) : (
                  <div className='text-muted'>This company has no signages.</div>
                )}
              </div>
            </section>
          </Row>
        </Row>
      </>
    )
  },
)
